import { FieldPreparationEvent } from "model";

export type FieldPreparationEventFormData = {
  note?: string;
  fieldPreparationEventDate: Date;
  fieldGuids: string[];
};
export const convertFromFormInput = (
  fieldPreparationFormData: FieldPreparationEventFormData
): FieldPreparationEvent => {
  return {
    note: fieldPreparationFormData.note,
    fieldPreparationEventDate: new Date(
      fieldPreparationFormData.fieldPreparationEventDate
    ).toISOString(),
    fieldGuids: fieldPreparationFormData.fieldGuids,
    guid: "",
  };
};
